<template>
  <div
    class="video-tag"
    :class="{ 'size-small': size === 'small', 'size-medium': size === 'medium' }"
  >
    <span class="hitems-video-play"></span>
  </div>
</template>

<script setup lang="ts">
  import type { PropType } from 'vue'
  defineOptions({
    name: 'VideoIcon'
  })

  const props = defineProps({
    size: {
      type: String as PropType<'small' | 'medium' | 'large'>,
      default: 'large'
    }
  })
</script>

<style scoped lang="stylus">
  @import './index.styl';
</style>
